import { TranslationUtilProvider, TranslationUtilStringProvider } from "./@types/provider";
import { Weglot } from "./providers/Weglot";
import { Langify } from "./providers/Langify";
import { Native } from "./providers/Native";
class TranslationUtil {
    static async search(tranlationProvider, words, languageTo, callback) {
        switch (tranlationProvider) {
            case TranslationUtilProvider.WEGLOT:
                return Weglot.search(words, languageTo, callback);
            default:
                return words;
        }
    }
    static async translate(tranlationProvider, words, languageTo) {
        switch (tranlationProvider) {
            case TranslationUtilProvider.WEGLOT:
                return Weglot.translate(words, languageTo);
            default:
                return words;
        }
        return words;
    }
    static getCurrentLanguage(tranlationProvider) {
        switch (tranlationProvider) {
            case TranslationUtilProvider.WEGLOT:
                return Weglot.getCurrentLanguage();
            case TranslationUtilProvider.LANGIFY:
                return Langify.getCurrentLanguage();
            case TranslationUtilProvider.NATIVE:
                return Native.getCurrentLanguage();
            default:
                return 'en';
        }
        return 'en';
    }
    static getCurrentProvider() {
        if (typeof (window?.Weglot) !== "undefined") {
            return TranslationUtilProvider.WEGLOT;
        }
        else if (typeof (window?.langify) !== "undefined") {
            return TranslationUtilProvider.LANGIFY;
        }
        else {
            return TranslationUtilProvider.NONE;
        }
    }
    static getProductUrl(tranlationProvider, productUrl) {
        switch (tranlationProvider) {
            case TranslationUtilProvider.WEGLOT:
                return productUrl;
            case TranslationUtilProvider.LANGIFY:
                return Langify.getProductUrl(productUrl);
            default:
                return productUrl;
        }
        return productUrl;
    }
    static getLangifyStoreId() {
        return this.getCurrentProvider() === TranslationUtilProvider.LANGIFY ? Langify.getStoreId() : null;
    }
    static getNativeStoreId() {
        return Native.getStoreId();
    }
    static getTranslatedUrl(translationProvider, url) {
        switch (translationProvider) {
            case TranslationUtilProvider.WEGLOT:
                return url;
            case TranslationUtilProvider.LANGIFY:
                return Langify.getTranslatedUrl(url);
            default:
                return url;
        }
        return url;
    }
}
export { TranslationUtil, TranslationUtilProvider, TranslationUtilStringProvider };
//# sourceMappingURL=main.js.map